import React, { useMemo } from 'react'

// import * as SC from './styles';

const EndCard = () => {
    return null
}

export default EndCard
